var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGraphUp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M4.7 4.083a.7.7 0 1 0-1.4 0v16a.7.7 0 0 0 .7.7h16a.7.7 0 1 0 0-1.4H4.7v-2.496l7.285-6.83 2.52 2.521a.7.7 0 0 0 .99 0l4.5-4.5a.7.7 0 0 0-.99-.99l-4.004 4.005-2.505-2.505a.7.7 0 0 0-.974-.015l-6.821 6.394z"
})));
export default SvgGraphUp;